import { useState } from "react";
import Header from "../../../../customs/Header";
import SettingsModal from "../Modal/settingsCustomModal";
import CreateRoutePayment from "./CreateRoutePayment";
import DynamicTable from "./table";
import apiCall from "../../../../utils/apiCall";
import { useQueries, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { CircularProgress, styled } from "@mui/material";
import { FilterDropDown } from "../../../../ui-components";
import styles from "../css/routePayment.module.css";
import { AiOutlineSearch as SearchIcon } from "react-icons/ai";
import { IoReload as ReloadIcon } from "react-icons/io5";

interface RoutePayment {
  RoutPaymentId: number;
  RoutId: number;
  RouteName: string;
  ActionId: number;
  ActionName: string;
  Amount: number;
  Amount_B: number;
  PaymentActive: boolean;
  OrderOfPayment: number;
  TargetedMembersId: number;
  TargetedMembers: string;
}

interface RouteResponse {
  StatusCode: number;
  Message: string;
  Data: Route[];
}

interface Route {
  RouteName: string;
  RouteId: number;
  Status: boolean;
  StateDate: string;
  EndDate: string;
}

const RoutePayment = () => {
  const [openRoutePaymentModal, setOpenRoutePaymentModal] = useState(false);
  const [routeId, setRouteId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [routeName, setRouteName] = useState("");

  const handleOpenRoutePaymentModal = () => setOpenRoutePaymentModal(true);
  const handleCloseRoutePaymentModal = () => setOpenRoutePaymentModal(false);

  const getRoutePayment = async (): Promise<RoutePayment[]> => {
    return (await apiCall().get(`/Routes/GetAllRoutePayments`))?.data;
  };

  const getAllRoute = async (): Promise<RouteResponse> => {
    return (await apiCall().get(`/Routes/GetAllRoute`))?.data;
  };

  const [getRoutePaymentQuery, getAllRouteQuery] = useQueries({
    queries: [
      { queryKey: ["get-routePayment", searchData], queryFn: getRoutePayment },
      { queryKey: ["get-all-route"], queryFn: getAllRoute },
    ],
  });

  const membershipRoute = [
    { RouteId: 1, RouteName: "Examination/NYSC" },
    { RouteId: 2, RouteName: "Practitioner" },
    { RouteId: 3, RouteName: "Executive" },
    { RouteId: 4, RouteName: "Academic" },
    { RouteId: 5, RouteName: "Military & ParaMilitary" },
    { RouteId: 6, RouteName: "Corporate" },
  ];

  const mappedRouteData: any[] | undefined = membershipRoute?.map((item) => {
    let route = {
      val: item?.RouteId,
      name: item?.RouteName,
    };
    return route;
  });

  const handleRouteIdChange = (route: { val: string; name: string }) => {
    setRouteId(route?.val);
    setRouteName(route?.name);
  };

  //Filter table by Route Name
  const filteredData =
    getRoutePaymentQuery?.data &&
    getRoutePaymentQuery?.data?.filter(
      (data) => Number(routeId) === data?.RoutId
    );

  const errorMessageBioData = getRoutePaymentQuery.error as AxiosError;

  const searchFilteredData = getRoutePaymentQuery?.data?.filter((x) =>
    Object.values(x).join(" ").toLowerCase().includes(searchData.toLowerCase())
  );

  return (
    <>
      <div>
        <Header
          marginBlockEnd={"63px"}
          props={{
            firstName: routeName === "" ? "All" : routeName,
            secondName: "Route Payment",
            buttonText: "Create Route Payment",
          }}
          handleOpen={handleOpenRoutePaymentModal}
        />

        <div className={styles.container}>
          <div className={styles.filterDiv}>
            <label className={styles.searchForm}>
              <span className={styles.sI}>
                <SearchIcon />
              </span>
              <input
                value={searchData}
                onChange={(e) => setSearchData(e?.target?.value)}
                type="text"
                placeholder="Search"
              />
              <button className={styles.rBtn} type="submit">
                <ReloadIcon />
              </button>
            </label>
            <FilterDropDown
              onChange={handleRouteIdChange}
              text="Route"
              bg="#0A3922"
              color="#fff"
              options={mappedRouteData}
              replace={"true"}
            />
          </div>
        </div>
        {getRoutePaymentQuery?.isLoading ? (
          <CircleStyle>
            <CircularProgress
              sx={{
                fontSize: "1rem",
                marginInline: "auto",
                display: "block",
                marginBlock: "2rem",
                color: "#11643C",
              }}
            />
          </CircleStyle>
        ) : getRoutePaymentQuery?.isError ? (
          <StyledError>{errorMessageBioData?.message}</StyledError>
        ) : (
          <DynamicTable
            data={
              Number(routeId) > 0
                ? filteredData
                : searchData.length > 0
                ? searchFilteredData
                : getRoutePaymentQuery?.data
            }
          />
        )}

        <SettingsModal
          open={openRoutePaymentModal}
          cancel={handleCloseRoutePaymentModal}
          maxWidth="800px"
          header="Route Payment"
          showrightIcon={false}
          content={
            <CreateRoutePayment handleClose={handleCloseRoutePaymentModal} />
          }
        />
      </div>
      {/* {showModal ? <Modal click={handleModal}/>:<></>} */}
    </>
  );
};

export default RoutePayment;

const StyledError = styled("p")`
  color: red;
  font-size: 1.4rem;
  display: flex;
`;

const CircleStyle = styled("div")`
  width: 100% dispay flex;
  justify-content: center;
  align-items: center;
`;
